export default __webpack_public_path__ + "static/media/Clean, Silly, Cheerful, Young.296ec9b3.jpg";